export default {
  title: 'Unisciti a {{name}}!',
  default_program_name: 'Rewards Club',
  savings_highlight: {
    title: 'Vieni premiato. Ad ogni ordine, ogni volta.',
    subtitle: 'Registrati in pochi secondi e inizia a guadagnare punti.',
  },
  how_it_works: {
    label: 'Come funziona',
    step_1: {
      title: 'Registrati in 30s',
      desc: 'Solo il tuo numero di telefono',
    },
    step_2: {
      title: 'Ordina e guadagna',
      desc: '{{percentage}}% di rimborso su ogni ordine',
    },
    step_3: {
      title: 'Riscatta e risparmia',
      desc: 'Fino a {{amount}} di sconto per ordine',
    },
  },
  profile: {
    verified_title: 'Telefono verificato!',
    verified_subtitle: 'Completa il tuo profilo per iniziare a guadagnare.',
  },
  form: {
    phone_number: {
      label: 'Numero di telefono',
      description: 'Ti invieremo un codice di verifica per confermare la tua identità.',
      placeholder: 'Numero di telefono',
    },
    birthday: {
      label: 'Compleanno — giorno e mese bastano per ricevere un regalo 🥳',
      placeholder: 'Compleanno (facoltativo)',
      parts: {
        month: 'Mese',
        day: 'Giorno',
      },
    },
  },
  terms:
    'Registrandoti, accetti i nostri <TermsLink>termini e condizioni</TermsLink> e acconsenti alla nostra <PrivacyPolicyLink>informativa sulla privacy</PrivacyPolicyLink>.',
  buttons: {
    continue: 'Continua',
    verify: 'Verifica',
    complete: 'Completa la registrazione',
  },
  toasts: {
    login_success: "Hai effettuato l'accesso con successo",
    invalid_code: 'Codice non valido. Riprova.',
    failed_to_update_profile: 'Aggiornamento del profilo non riuscito. Riprova.',
  },
};
